import { render } from "./dpw-table.vue?vue&type=template&id=6a15ac00&scoped=true"
import script from "./dpw-table.vue?vue&type=script&lang=js"
export * from "./dpw-table.vue?vue&type=script&lang=js"

import "./dpw-table.vue?vue&type=style&index=0&id=6a15ac00&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a15ac00"]])

export default __exports__